<template>
  <div class="swiper-comp-wrapper hidden-xs">
    <div class="swiper-container-product">
      <div class="swiper-wrapper">
        <img-item v-for="item in items" :key="item.src" :item="item" />
      </div>
    </div>
    <div class="swiper-button-next">
      <span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>
    </div>
    <div class="swiper-button-prev">
      <span class="glyphicon glyphicon-menu-left" aria-hidden="true"></span>
    </div>
  </div>
</template>
<script>
import ImgItem from "./imgItem.vue";
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
  name: "ProductHome",
  components: {
    ImgItem,
  },
  data() {
    return {
      items: [
        {
          src: require("../../assets/product/1.png"),
          text: "适合行政事业单位，是B/S架构，兼容最新政府财务制度和以前的行政财务制度同时并存，可以上传电子附件并支持查阅打印等，同时可以作为财务电子凭证库管理系统使用。",
          title: "同慧易财财务系统",
        },
        {
          src: require("../../assets/product/2.png"),
          text: "是一款致力于实物资产管理的信息系统，着力于固定资产管理的流程控制，审核，单据打印，数据查询处理等问题，分入账与非入账模式，方便与财务对账的同时，亦符合实物管理的特性。",
          title: "同慧内控资产管理系统",
        },
        {
          src: require("../../assets/product/3.png"),
          text: "适合省内法院单位，是B/S架构，为法院系统专力打造的财务系统。支持从南京通达海公司的案款系统同步数据，也支持客户用excel导入生成凭证。用户可通过凭证录入上传附件。系统支持多年度跨年查询数据，一键账本打......",
          title: "同慧法院专版财务系统",
        },
        {
          src: require("../../assets/product/4.png"),
          text: "文件管理模块是系统核心功能模块,主要功能包括文件上传下载,文件资源浏览,文件资源搜索,文件分类管理,文件的基础操作等。文件上传采用组件作为文件上传工具,文件下载模块主要是对用户请求下载的文件进行处理，文件......",
          title: "同慧内控文件管理系统",
        },
        {
          src: require("../../assets/product/5.png"),
          text: "规范单位的人事管理,降低人事部门的工作负荷,提高工作效率和工作质量，集成化和自动化程度高的新系统的显得尤为重要，可以为对单位提供更优服务，对数据统计、分析工作提供更准确，提供更强、更有利的支持，该系统......",
          title: "同慧内控人事管理系统",
        },
        {
          src: require("../../assets/product/6.png"),
          text: "内部控制，是单位为实现控制目标，通过制定制度、实施措施和执行程序对经济活动风险进行防范和管控。高效的报销系统能够帮助单位自动化费用管理流程，消除人为错误以及其他繁琐环节，从而节省员工的时间和资源......",
          title: "同慧内控报销管理系统",
        },
      ],
    };
  },
  mounted() {
    new Swiper(".swiper-container-product", {
      slidesPerView: 4,
      spaceBetween: 0,
      loop: true,
      autoplay: {
        delay: 5000,
        // 用户操作swiper之后，是否禁止autoplay
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  },
};
</script>
<style scoped>
.swiper-comp-wrapper{
    position: relative;
    margin-top: 18px;
}
.swiper-container-product {
  overflow: hidden;
}
.swiper-button-next,
.swiper-button-prev {
  width: 20px;
  height: 20px;
  border: 1px solid #b2b2b2;
  color: #b2b2b2;
  border-radius: 50%;
}
.swiper-button-prev {
  left: -46px;
}
.swiper-button-next {
  right: -46px;
}
.swiper-button-next:hover,
.swiper-button-prev:hover {
  color: #4377de;
  border-color: #4377de;
}
.swiper-button-next::after,
.swiper-button-prev::after {
  font-size: 0px;
  content: '';
}
</style>


// WEBPACK FOOTER //
// src/components/product/SwiperComp.vue